import { API } from 'aws-amplify';

import {
	FETCH_NI_SMELTER_ALL_TIME_BY_SMELTER_DATA_INIT,
	FETCH_NI_SMELTER_ALL_TIME_BY_SMELTER_DATA,
	FETCH_NI_SMELTER_ALL_TIME_BY_SMELTER_DATA_ERR,
	FETCH_NI_SMELTER_DATA_INIT,
	FETCH_NI_SMELTER_DATA,
	FETCH_NI_SMELTER_DATA_ERR,
	RESET_NI_SMELTER_DATA,
	FETCH_NI_SMELTER_CAPACITY_INIT,
	FETCH_NI_SMELTER_CAPACITY,
	FETCH_NI_SMELTER_CAPACITY_ERR,
	RESET_NI_SMELTER_CAPACITY,
	FETCH_NI_SMELTERS_STATE,
	FETCH_NI_SMELTERS_STATE_ERR,
	FETCH_NI_SMELTER_RECENT,
	FETCH_NI_SMELTER_RECENT_ERR,
	SELECT_NI_SMELTER,
	UNSELECT_NI_SMELTER
} from '../';
import config from '../../config';
import { replacer } from '../../utils';
import { clearApiRetry, showApiMessages } from '../../apiMessages';

export const fetchNiSmelterData =
	({ grouping, ids, dateFrom: startDate = '', dateTo: endDate = '' }) =>
	async (dispatch, getState) => {
		const retryKey = JSON.stringify({
			grouping,
			ids,
			dateFrom: startDate,
			dateTo: endDate
		});
		clearApiRetry('Nickel indices', retryKey);
		const timestamp = Date.now();
		dispatch({ type: FETCH_NI_SMELTER_DATA_INIT, payload: { timestamp } });
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.niSmelterData, {
				grouping,
				ids,
				startDate,
				endDate
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				showApiMessages({
					retryKey,
					response,
					sites: getState ? getState().sites : [],
					title: 'Nickel indices'
				});
				dispatch({
					type: FETCH_NI_SMELTER_DATA,
					payload: { data: response, timestamp }
				});
			},
			(err) => {
				showApiMessages({
					retryKey,
					response: { error: err },
					title: 'Nickel indices',
					onRetry: () => dispatch(fetchNiSmelterData({
						grouping,
						ids,
						dateFrom: startDate,
						dateTo: endDate
					}))
				});
				return dispatch({
					type: FETCH_NI_SMELTER_DATA_ERR,
					payload: { error: err, timestamp }
				});
			}
		);
	};

export const resetNiSmelterData = () => (dispatch) => {
	clearApiRetry('Nickel indices');
	return dispatch({ type: RESET_NI_SMELTER_DATA });
};

export const fetchNiSmelterCapacity =
	({ grouping, ids, dateFrom: startDate = '', dateTo: endDate = '' }) =>
	async (dispatch, getState) => {
		const retryKey = JSON.stringify({
			grouping,
			ids,
			dateFrom: startDate,
			dateTo: endDate
		});
		clearApiRetry('Nickel capacity', retryKey);
		const timestamp = Date.now();
		dispatch({
			type: FETCH_NI_SMELTER_CAPACITY_INIT,
			payload: { timestamp }
		});
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.niSmelterCapacity, {
				grouping,
				ids,
				startDate,
				endDate
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				showApiMessages({
					retryKey,
					response,
					sites: getState ? getState().sites : [],
					title: 'Nickel capacity'
				});
				dispatch({
					type: FETCH_NI_SMELTER_CAPACITY,
					payload: { data: response, timestamp }
				});
			},
			(err) => {
				showApiMessages({
					retryKey,
					response: { error: err },
					title: 'Nickel capacity',
					onRetry: () => dispatch(fetchNiSmelterCapacity({
						grouping,
						ids,
						dateFrom: startDate,
						dateTo: endDate
					}))
				});
				return dispatch({
					type: FETCH_NI_SMELTER_CAPACITY_ERR,
					payload: err
				});
			}
		);
	};

export const resetNiSmelterCapacity = () => (dispatch) => {
	clearApiRetry('Nickel capacity');
	return dispatch({ type: RESET_NI_SMELTER_CAPACITY });
};

// export const fetchSteelSmelterProduction =
// 	({
// 		grouping,
// 		ids,
// 		collapse,
// 		plant,
// 		dateFrom: startDate = '',
// 		dateTo: endDate = ''
// 	}) =>
// 	async (dispatch) => {
// 		const timestamp = Date.now();
// 		dispatch({
// 			type: FETCH_NI_SMELTER_PRODUCTION_INIT,
// 			payload: { timestamp }
// 		});
// 		const request = API.get(
// 			'gains-api',
// 			replacer(config.apiEndpoints.steelSmelterProduction, {
// 				grouping,
// 				ids,
// 				collapse,
// 				plant,
// 				startDate,
// 				endDate
// 			}),
// 			{
// 				headers: {}
// 			}
// 		);

// 		return request.then(
// 			(response) => {
// 				dispatch({
// 					type: FETCH_NI_SMELTER_PRODUCTION,
// 					payload: { data: response, timestamp }
// 				});
// 			},
// 			(err) =>
// 				dispatch({
// 					type: FETCH_NI_SMELTER_PRODUCTION_ERR,
// 					payload: err
// 				})
// 		);
// 	};

// export const fetchCsvSteelProductionData = async ({
// 	grouping,
// 	ids,
// 	plantTypes,
// 	csvAllPlantTypes,
// 	dateFrom,
// 	dateTo
// }) => {
// 	const csvPlantTypes = csvAllPlantTypes ? ['bfbof', 'eaf'] : plantTypes;
// 	const task_type_default = ({ collapse, startDate, endDate }) => ({
// 		name: collapse,
// 		task: () =>
// 			API.get(
// 				'gains-api',
// 				replacer(config.apiEndpoints.steelSmelterProduction, {
// 					grouping,
// 					ids,
// 					collapse,
// 					plant: '',
// 					startDate: startDate.format('YYYY-MM-DD'),
// 					endDate: endDate.format('YYYY-MM-DD')
// 				}),
// 				{
// 					headers: {}
// 				}
// 			)
// 	});

// 	const task_type_0 = ({ collapse, startDate, endDate }) => ({
// 		name: `${collapse}_${csvPlantTypes[0]}`,
// 		task: () =>
// 			API.get(
// 				'gains-api',
// 				replacer(config.apiEndpoints.steelSmelterProduction, {
// 					grouping,
// 					ids,
// 					collapse,
// 					plant: csvPlantTypes[0],
// 					startDate: startDate.format('YYYY-MM-DD'),
// 					endDate: endDate.format('YYYY-MM-DD')
// 				}),
// 				{
// 					headers: {}
// 				}
// 			)
// 	});

// 	const task_type_1 = ({ collapse, startDate, endDate }) => ({
// 		name: `${collapse}_${csvPlantTypes[1]}`,
// 		task: () =>
// 			API.get(
// 				'gains-api',
// 				replacer(config.apiEndpoints.steelSmelterProduction, {
// 					grouping,
// 					ids,
// 					collapse,
// 					plant: csvPlantTypes[1],
// 					startDate: startDate.format('YYYY-MM-DD'),
// 					endDate: endDate.format('YYYY-MM-DD')
// 				}),
// 				{
// 					headers: {}
// 				}
// 			)
// 	});

// 	const collapses = ['daily', 'weekly', 'monthly', 'annual'];
// 	const tasks = [];
// 	let startDate = moment.utc(dateFrom);
// 	const dateRanges = [];
// 	while (startDate.isBefore(dateTo)) {
// 		let endDate = startDate
// 			.clone()
// 			.add(2, 'y')
// 			.startOf('year')
// 			.subtract(1, 'd');
// 		if (endDate.isAfter(dateTo)) {
// 			endDate = moment.utc(dateTo);
// 		}
// 		dateRanges.push({ startDate, endDate });
// 		startDate = endDate.clone().add(1, 'd');
// 	}
// 	dateRanges.forEach(({ startDate, endDate }) =>
// 		collapses.forEach((collapse) => {
// 			if (csvPlantTypes.length === 0 || csvPlantTypes.length === 2) {
// 				tasks.push(task_type_default({ collapse, startDate, endDate }));
// 				if (csvPlantTypes.length) {
// 					tasks.push(
// 						...[
// 							task_type_0({ collapse, startDate, endDate }),
// 							task_type_1({ collapse, startDate, endDate })
// 						]
// 					);
// 				}
// 			} else {
// 				tasks.push(task_type_0({ collapse, startDate, endDate }));
// 			}
// 		})
// 	);

// 	try {
// 		return await runAsyncTasks(tasks, 1);
// 	} catch (error) {
// 		toastr.error(`Download production data, ${error} `);
// 		return [];
// 	}
// };

// export const fetchSteelSmelterProductionSubsites =
// 	({
// 		grouping,
// 		ids,
// 		subsiteType,
// 		collapse,
// 		dateFrom: startDate = '',
// 		dateTo: endDate = ''
// 	}) =>
// 	async (dispatch) => {
// 		const timestamp = Date.now();
// 		dispatch({
// 			type: FETCH_NI_SMELTER_PRODUCTION_SUBSITES_INIT,
// 			payload: { timestamp }
// 		});
// 		const request = API.get(
// 			'gains-api',
// 			replacer(config.apiEndpoints.steelSmelterProductionSubsites, {
// 				grouping,
// 				ids,
// 				subsiteType,
// 				collapse,
// 				startDate,
// 				endDate
// 			}),
// 			{
// 				headers: {}
// 			}
// 		);

// 		return request.then(
// 			(response) => {
// 				dispatch({
// 					type: FETCH_NI_SMELTER_PRODUCTION_SUBSITES,
// 					payload: { data: response, timestamp }
// 				});
// 			},
// 			(err) =>
// 				dispatch({
// 					type: FETCH_NI_SMELTER_PRODUCTION_SUBSITES_ERR,
// 					payload: err
// 				})
// 		);
// 	};

// export const fetchCsvSteelProductionDataSubsites = async ({
// 	grouping,
// 	ids,
// 	subsiteType,
// 	dateFrom,
// 	dateTo
// }) => {
// 	const task_type_default = ({ collapse, startDate, endDate }) => ({
// 		name: collapse,
// 		task: () =>
// 			API.get(
// 				'gains-api',
// 				replacer(config.apiEndpoints.steelSmelterProductionSubsites, {
// 					grouping,
// 					ids,
// 					subsiteType,
// 					collapse,
// 					startDate: startDate.format('YYYY-MM-DD'),
// 					endDate: endDate.format('YYYY-MM-DD')
// 				}),
// 				{
// 					headers: {}
// 				}
// 			)
// 	});

// 	const collapses = ['daily', 'weekly', 'monthly', 'annual'];
// 	const tasks = [];
// 	let startDate = moment.utc(dateFrom);
// 	const dateRanges = [];
// 	while (startDate.isBefore(dateTo)) {
// 		let endDate = startDate
// 			.clone()
// 			.add(2, 'y')
// 			.startOf('year')
// 			.subtract(1, 'd');
// 		if (endDate.isAfter(dateTo)) {
// 			endDate = moment.utc(dateTo);
// 		}
// 		dateRanges.push({ startDate, endDate });
// 		startDate = endDate.clone().add(1, 'd');
// 	}
// 	dateRanges.forEach(({ startDate, endDate }) =>
// 		collapses.forEach((collapse) => {
// 			tasks.push(task_type_default({ collapse, startDate, endDate }));
// 		})
// 	);
// 	try {
// 		return await runAsyncTasks(tasks, 1);
// 	} catch (error) {
// 		toastr.error(`Download production data, ${error} `);
// 		return [];
// 	}
// };

// export const fetchSteelSmelterCO2Emissions =
// 	({
// 		grouping,
// 		ids,
// 		collapse,
// 		plant,
// 		dateFrom: startDate = '',
// 		dateTo: endDate = ''
// 	}) =>
// 	async (dispatch) => {
// 		const timestamp = Date.now();
// 		dispatch({
// 			type: FETCH_NI_SMELTER_CO2_EMISSIONS_INIT,
// 			payload: { timestamp }
// 		});
// 		const request = API.get(
// 			'gains-api',
// 			replacer(config.apiEndpoints.steelSmelterCO2Emissions, {
// 				grouping,
// 				ids,
// 				collapse,
// 				plant,
// 				startDate,
// 				endDate
// 			}),
// 			{
// 				headers: {}
// 			}
// 		);

// 		return request.then(
// 			(response) => {
// 				dispatch({
// 					type: FETCH_NI_SMELTER_CO2_EMISSIONS,
// 					payload: { data: response, timestamp }
// 				});
// 			},
// 			(err) =>
// 				dispatch({
// 					type: FETCH_NI_SMELTER_CO2_EMISSIONS_ERR,
// 					payload: err
// 				})
// 		);
// 	};

// export const fetchCsvSteelCO2EmissionsData = async ({
// 	grouping,
// 	ids,
// 	plantTypes,
// 	csvAllPlantTypes,
// 	dateFrom,
// 	dateTo
// }) => {
// 	const csvPlantTypes = csvAllPlantTypes ? ['bfbof', 'eaf'] : plantTypes;
// 	const task_type_default = ({ collapse, startDate, endDate }) => ({
// 		name: collapse,
// 		task: () =>
// 			API.get(
// 				'gains-api',
// 				replacer(config.apiEndpoints.steelSmelterCO2Emissions, {
// 					grouping,
// 					ids,
// 					collapse,
// 					plant: '',
// 					startDate: startDate.format('YYYY-MM-DD'),
// 					endDate: endDate.format('YYYY-MM-DD')
// 				}),
// 				{
// 					headers: {}
// 				}
// 			)
// 	});

// 	const task_type_0 = ({ collapse, startDate, endDate }) => ({
// 		name: `${collapse}_${csvPlantTypes[0]}`,
// 		task: () =>
// 			API.get(
// 				'gains-api',
// 				replacer(config.apiEndpoints.steelSmelterCO2Emissions, {
// 					grouping,
// 					ids,
// 					collapse,
// 					plant: csvPlantTypes[0],
// 					startDate: startDate.format('YYYY-MM-DD'),
// 					endDate: endDate.format('YYYY-MM-DD')
// 				}),
// 				{
// 					headers: {}
// 				}
// 			)
// 	});

// 	const task_type_1 = ({ collapse, startDate, endDate }) => ({
// 		name: `${collapse}_${csvPlantTypes[1]}`,
// 		task: () =>
// 			API.get(
// 				'gains-api',
// 				replacer(config.apiEndpoints.steelSmelterCO2Emissions, {
// 					grouping,
// 					ids,
// 					collapse,
// 					plant: csvPlantTypes[1],
// 					startDate: startDate.format('YYYY-MM-DD'),
// 					endDate: endDate.format('YYYY-MM-DD')
// 				}),
// 				{
// 					headers: {}
// 				}
// 			)
// 	});

// 	const collapses = ['daily', 'weekly', 'monthly', 'annual'];
// 	const tasks = [];
// 	let startDate = moment.utc(dateFrom);
// 	const dateRanges = [];
// 	while (startDate.isBefore(dateTo)) {
// 		let endDate = startDate
// 			.clone()
// 			.add(2, 'y')
// 			.startOf('year')
// 			.subtract(1, 'd');
// 		if (endDate.isAfter(dateTo)) {
// 			endDate = moment.utc(dateTo);
// 		}
// 		dateRanges.push({ startDate, endDate });
// 		startDate = endDate.clone().add(1, 'd');
// 	}
// 	dateRanges.forEach(({ startDate, endDate }) =>
// 		collapses.forEach((collapse) => {
// 			if (csvPlantTypes.length === 0 || csvPlantTypes.length === 2) {
// 				tasks.push(task_type_default({ collapse, startDate, endDate }));
// 				if (csvPlantTypes.length) {
// 					tasks.push(
// 						...[
// 							task_type_0({ collapse, startDate, endDate }),
// 							task_type_1({ collapse, startDate, endDate })
// 						]
// 					);
// 				}
// 			} else {
// 				tasks.push(task_type_0({ collapse, startDate, endDate }));
// 			}
// 		})
// 	);

// 	try {
// 		return await runAsyncTasks(tasks, 1);
// 	} catch (error) {
// 		toastr.error(`Download CO2 emissions data, ${error} `);
// 		return [];
// 	}
// };

// export const resetSteelSmelterProduction = () => (dispatch) =>
// 	dispatch({ type: RESET_NI_SMELTER_PRODUCTION });

// export const resetSteelSmelterProductionSubsites = () => (dispatch) =>
// 	dispatch({ type: RESET_NI_SMELTER_PRODUCTION_SUBSITES });

// export const resetSteelSmelterCO2Emissions = () => (dispatch) =>
// 	dispatch({ type: RESET_NI_SMELTER_CO2_EMISSIONS });

// export const fetchWorldSteelData = async ({
// 	grouping,
// 	id,
// 	collapse,
// 	dateFrom: startDate = '',
// 	dateTo: endDate = ''
// }) => {
// 	return await API.get(
// 		'gains-api',
// 		replacer(config.apiEndpoints.worldSteelData, {
// 			grouping,
// 			id,
// 			collapse,
// 			startDate,
// 			endDate
// 		}),
// 		{
// 			headers: {}
// 		}
// 	);
// };

// export const fetchWorldSteelRegions = async ({ subsiteType }) => {
// 	return await API.get(
// 		'gains-api',
// 		replacer(config.apiEndpoints.worldSteelRegions, {
// 			subsiteType
// 		}),
// 		{
// 			headers: {}
// 		}
// 	);
// };
// export const fetchWorldSteelSubsitesData = async ({
// 	grouping,
// 	id,
// 	subsiteType,
// 	collapse,
// 	dateFrom: startDate = '',
// 	dateTo: endDate = ''
// }) => {
// 	return await API.get(
// 		'gains-api',
// 		replacer(config.apiEndpoints.worldSteelSubsitesData, {
// 			grouping,
// 			id,
// 			subsiteType,
// 			collapse,
// 			startDate,
// 			endDate
// 		}),
// 		{
// 			headers: {}
// 		}
// 	);
// };

export const fetchNiAllTimeBySmelterData =
	({ smelterIds }) =>
	async (dispatch) => {
		const timestamp = Date.now();
		dispatch({ type: FETCH_NI_SMELTER_ALL_TIME_BY_SMELTER_DATA_INIT, payload: { timestamp } });
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.niAllTimeBySmelterData, {
				smelterIds
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) =>
				dispatch({
					type: FETCH_NI_SMELTER_ALL_TIME_BY_SMELTER_DATA,
					payload: { ...response, timestamp }
				}),
			(err) =>
				dispatch({
					type: FETCH_NI_SMELTER_ALL_TIME_BY_SMELTER_DATA_ERR,
					payload: { error: err, timestamp }
				})
		);
	};

export const resetNiAllTimeBySmelterData = () => ({
	type: FETCH_NI_SMELTER_ALL_TIME_BY_SMELTER_DATA,
	payload: {}
});

export const fetchNiSmeltersState =
	({ grouping, ids, searchDate }) =>
	async (dispatch) => {
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.niSmeltersStatus, {
				grouping,
				ids,
				searchDate
			}),

			{
				headers: {}
			}
		);

		return request.then(
			(response) =>
				dispatch({
					type: FETCH_NI_SMELTERS_STATE,
					payload: response
				}),
			(err) =>
				dispatch({
					type: FETCH_NI_SMELTERS_STATE_ERR,
					payload: err
				})
		);
	};

export const resetNiSmeltersState = () => ({
	type: FETCH_NI_SMELTERS_STATE,
	payload: []
});

// export const fetchSteelSmelterList = () => async (dispatch) => {
// 	const request = API.get('savant-api', config.apiEndpoints.steelSmelterList, {
// 		headers: await getAuthHeaders()
// 	});

// 	return request.then(
// 		(response) => {
// 			dispatch({
// 				type: FETCH_NI_SMELTER_LIST,
// 				payload: response
// 			});
// 		},
// 		(err) =>
// 			dispatch({
// 				type: FETCH_NI_SMELTER_LIST_ERR,
// 				payload: err
// 			})
// 	);
// };

export const fetchNiSmelterRecent = () => async (dispatch) => {
	const request = API.get('gains-api', config.apiEndpoints.niSmelterRecent, {});
	return request.then(
		(response) => {
			dispatch({
				type: FETCH_NI_SMELTER_RECENT,
				payload: response
			});
		},
		(err) =>
			dispatch({
				type: FETCH_NI_SMELTER_RECENT_ERR,
				payload: err
			})
	);
};

// export const fetchSteelSmelterRegions = () => async (dispatch) => {
// 	const request = API.get(
// 		'savant-api',
// 		config.apiEndpoints.steelSmelterRegions,
// 		{
// 			headers: await getAuthHeaders()
// 		}
// 	);

// 	return request.then(
// 		(response) =>
// 			dispatch({
// 				type: FETCH_NI_SMELTER_REGIONS,
// 				payload: response
// 			}),
// 		(err) =>
// 			dispatch({
// 				type: FETCH_NI_SMELTER_REGIONS_ERR,
// 				payload: err
// 			})
// 	);
// };

// export const fetchSteelSmelterUpdates =
// 	({ regions, dateFrom: startDate = '', dateTo: endDate = '' }) =>
// 	async (dispatch) => {
// 		const request = API.get(
// 			'savant-api',
// 			replacer(config.apiEndpoints.steelSmelterUpdates, {
// 				regions,
// 				startDate,
// 				endDate
// 			}),
// 			{
// 				headers: await getAuthHeaders()
// 			}
// 		);
// 		return request.then(
// 			(response) => {
// 				dispatch({
// 					type: FETCH_NI_SMELTER_UPDATES,
// 					payload: response
// 				});
// 			},
// 			(err) =>
// 				dispatch({
// 					type: FETCH_NI_SMELTER_UPDATES_ERR,
// 					payload: err
// 				})
// 		);
// 	};

// export const resetSteelSmelterUpdates = () => {
// 	return (dispatch) => {
// 		dispatch({ type: FETCH_NI_SMELTER_UPDATES, payload: [] });
// 	};
// };

export const selectNiSmelter = (id) => ({
	type: SELECT_NI_SMELTER,
	payload: id
});

export const unselectNiSmelter = (id) => ({
	type: UNSELECT_NI_SMELTER,
	payload: id
});
